import { render, staticRenderFns } from "./update.vue?vue&type=template&id=f49831f6&scoped=true&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&id=f49831f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49831f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49831f6')) {
      api.createRecord('f49831f6', component.options)
    } else {
      api.reload('f49831f6', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=f49831f6&scoped=true&", function () {
      api.rerender('f49831f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/book/update.vue"
export default component.exports